import AllChallengesContainer from "@features/challenges/containers/AllChallengesContainer";

const AllChallengesRoute = () => {
	return <AllChallengesContainer />;
};

export default AllChallengesRoute;
